export const MarkerTypes = {
    VENUE: 'venue',
    PIN: 'pin',
};
